<template>
    <tr>
        <td>
            {{ user_log.loggable_type }}
        </td>
        <td>
            {{ user_log.title }}
        </td>
        <td>
            {{ user_log.action_type }}
        </td>
        <td>
            {{ user_log.operator_name }}
        </td>
        <td>
            {{ this.human_datetime(user_log.created_at) }}
        </td>
        <td>
            <router-link
            :to="{name: 'user_log', params: {identity: user_log.identity}}"
            class="ui basic primary button"
            >
                {{ $t('ui.general.detail') }}
            </router-link>
        </td>
    </tr>
</template>

<script>
export default {
    name: "ProviderUserLogsIndexItem",
    props: {
        user_log: Object
    },
    data() {
        return {
            is_processing: false,
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
    }
}
</script>
